<template>
  <div class="co-trade-box gray-cl e-2-cl" id="coTradeBox">
    <div class="title-block main-bg a-3-bd main-cl">
      <span
        class="show-dialog-btn gray-30-bg"
        :class="showClassType === 'depositDialogShow' ? 'blue-bg white-cl' : ''"
        @mouseenter="evenHandMouseenter('showClassType', 'depositDialogShow')"
        @mouseleave="evenHandMouseleave('showClassType')"
        @click="setShowDialog('depositDialogShow')"
      >
        {{ marginModelText }}
      </span>
      <span
        class="show-dialog-btn gray-30-bg"
        :class="showClassType === 'leverageDialogShow' ? 'blue-bg white-cl' : ''"
        @mouseenter="evenHandMouseenter('showClassType', 'leverageDialogShow')"
        @mouseleave="evenHandMouseleave('showClassType')"
        @click="setShowDialog('leverageDialogShow')"
      >
        {{ nowLevel }}X
      </span>

      <div class="counter-and-set">
        <!-- 合约计算器按钮 -->
        <i class="set-btn-icon" @click="showDialog('OPEN_CALCULATOR_DIALOG')">
          <svg-icon class-name="gray-cl" icon-class="futures-calculate"></svg-icon>
        </i>
        <!-- 合约设置按钮 -->
        <i class="set-btn-icon" @click="showDialog('SET_FUTURE_CONFIG')">
          <svg-icon class-name="gray-cl" icon-class="futures-set"></svg-icon>
        </i>
      </div>
    </div>

    <div class="trade-form">
      <!-- 开仓 平仓 (双向持仓可开启)-->
      <div class="category-select-box main-bg" v-if="positionModel === 2">
        <span
          class="tab flex tab-big"
          v-for="(item, index) in switchTradeTypeList"
          :key="index"
          @click="switchTradeType(item)"
          :class="item.classes"
        >
          <i class="">{{ item.text }}</i>
          <span class="selected blue-bg" v-if="transactionType === item.id"></span>
        </span>
      </div>
      <!-- 价格类型 限价单、市价单、条件单  -->
      <div class="category-select-box main-bg" style="padding-top: 8px">
        <span
          class="tab"
          v-for="(item, index) in categoryList"
          :key="index"
          @click="selectCategory(item.id)"
          :class="item.classes"
        >
          <i class="">{{ item.text }}</i>
        </span>
      </div>
      <div class="trade-inner main-bg">
        <!-- 价格 -->
        <form-input
          :promptText="formData_1.promptText"
          v-if="formData_1.isShow"
          :fix="formData_1.fix"
          :unit="formData_1.units"
          :title="formData_1.title"
          :default="formData_1.value"
          :isPercentage="formData_1.percentageVlaue"
          :isError="formData_1.errorText"
          @clearPercentage="clearPercentage"
          @tradeChangeValue="changeInput('formData_1', $event)"
        >
        </form-input>
        <div v-if="formData_1.errorText" class="form-error b-6-cl">{{ formData_1.errorText }}</div>
        <!-- 可用 -->
        <div class="available a-3-bd">
          <span class="rt-label a-1-bd">
            <!-- 可用 -->
            {{ lanText.text2 }}
            <!-- 可用余额为用户可自由支配的资金。可用余额会优先作为全仓保证金，当全仓仓位亏损时，可用就会减少。 -->
            <p class="tip-text main-second-bg main-cl" v-html="lanText.text3"></p>
          </span>
          <span class="main-cl">{{ thousandsComma(canUseAmount) }} {{ marginCoin }}</span>
        </div>
        <!-- 数量 -->
        <form-input
          :promptText="formData_2.promptText"
          v-if="formData_2.isShow"
          :isMarket="isMarket"
          :fix="formData_2.fix"
          :unit="formData_2.units"
          :default="formData_2.value"
          :title="formData_2.title"
          :haveMarket="true"
          :isError="formData_2.errorText"
          :percentageVlaue="percentageVlaue"
          @selectMarket="selectMarket"
          @clearPercentage="clearPercentage"
          @tradeChangeValue="changeInput('formData_2', $event)"
        >
        </form-input>
        <div v-if="formData_2.errorText" class="form-error b-6-cl">{{ formData_2.errorText }}</div>
        <form-input
          :promptText="formData_3.promptText"
          v-if="formData_3.isShow"
          :fix="formData_3.fix"
          :unit="formData_3.units"
          :title="formData_3.title"
          :default="formData_3.value"
          :isError="formData_3.errorText"
          :isPercentage="formData_3.percentageVlaue"
          @clearPercentage="clearPercentage"
          @tradeChangeValue="changeInput('formData_3', $event)"
        >
        </form-input>
        <div v-if="formData_3.errorText" class="form-error b-6-cl">{{ formData_3.errorText }}</div>
        <!-- 仓位价值  只有 （开仓 || 非只减仓） && 市价 显示 -->
        <p class="convert main-cl" v-if="isOpenAndIsMarket && !percentageVlaue">
          ≈ {{ worthRate }} <span> {{ multiplierCoin }}</span>
        </p>
        <p
          class="convert main-cl"
          v-if="currentCategory !== 2 && !isMarket && worthValue && !percentageVlaue"
        >
          <!-- 价值 -->
          {{ lanText.textjz }}
          {{ worthValue }}
          <template v-if="contractSide === 1">{{ priceUnit }}</template>
          <template v-else>{{ baseCoin }}</template>
        </p>
        <div class="percentage a-3-bd">
          <span
            v-for="item in percentageList"
            :key="item"
            @mouseenter="evenHandMouseenter('percentageVlaueHover', item)"
            @mouseout="evenHandMouseenter('percentageVlaueHover', null)"
            @click="setPercentageVlaue(item)"
            :class="
              percentageVlaue === item || percentageVlaueHover === item
                ? 'a-12-bd b-4-cl'
                : 'a-3-bd'
            "
          >
            {{ item }}%
          </span>
        </div>
        <!-- 可买 可卖 -->
        <div class="openable">
          <div class="left">
            <label :class="fixUpDownColor('u-1-cl')">{{ openableData.buyText }}</label>
            <span class="main-cl"> {{ thousandsComma(maxCanBuyNumber) }} {{ volUnit }}</span>
          </div>
          <div class="right">
            <label :class="fixUpDownColor('u-4-cl')">{{ openableData.sellText }}</label>
            <span class="main-cl"> {{ thousandsComma(maxCanSellNumber) }} {{ volUnit }} </span>
          </div>
        </div>
        <!-- 选项 -->
        <div class="option" v-if="currentCategory !== 2 || positionModel === 1">
          <template v-if="currentCategory !== 2 && !isMarket">
            <div class="select-order-type">
              <c-checkBox :value="isCheckedOrdeType" @click="checkedOrdeTypeclick" />
              <label class="ac-type">
                <div class="h-show">
                  <span class="tit a-1-bd">{{ ordeType.title }}</span>
                  <!--<span @click="ordeTypePtions = !ordeTypePtions" class="triangle-down b-4-bd"></span>-->
                  <svg-icon
                    class="icon-triangle-down"
                    @click="ordeTypePtions = !ordeTypePtions"
                    icon-class="icon-triangle-down"
                  ></svg-icon>
                </div>
                <div class="h-hide">
                  <span class="tit a-1-bd">{{ ordeType.title }}</span>
                  <!--<span @click="ordeTypePtions = !ordeTypePtions" class="triangle-down"></span>-->
                  <svg-icon
                    class="icon-triangle-down"
                    @click="ordeTypePtions = !ordeTypePtions"
                    icon-class="icon-triangle-down"
                  ></svg-icon>
                </div>
                <p class="tip-text main-second-bg main-cl">
                  {{ ordeType.text }}
                </p>
              </label>
              <!-- @mouseout="evenHandMouseenter('ordeTypePtions', false)" -->
              <div class="orde-type-ptions main-bg" v-show="ordeTypePtions">
                <p
                  v-for="item in ordeTypeList"
                  :key="item.id"
                  :class="
                    ordeType.id === item.id || hoverOrdeType.id === item.id
                      ? 'main-cl main-second-bg'
                      : 'main-second-bg'
                  "
                  @mouseenter.stop="evenHandMouseenter('hoverOrdeType', item)"
                  @mouseout.stop="evenHandMouseenter('hoverOrdeType', {})"
                  @click.stop="radioClick(item)"
                >
                  {{ item.title }}
                </p>
              </div>
            </div>
          </template>
          <!-- 只减仓（只要单向持仓会显示只减仓） -->
          <span v-if="positionModel === 1">
            <c-checkBox :value="zhiJianCang" @click="checkoutClick" />
            <!-- 只减仓 -->
            <label class="rt-label a-1-bd"
              >{{ lanText.text6 }}
              <p class="tip-text rt-label-zjc main-second-bg a-3-bd main-cl">
                <!-- 只减仓订单只会减少仓位，不会增加仓位。 -->
                {{ lanText.text7 }}
              </p>
            </label>
          </span>
        </div>
        <!-- 到期时间  有效期-->
        <!-- <form-select
          class="expireTime"
          v-if="currentCategory === 3"
          :label="lanText.text4"
          :list="planTypeList"
          :current="expireTime"
          @selectList="selectPlanType">
        </form-select> -->
        <!-- 买入 卖出 按钮 -->
        <div class="submit-button">
          <c-button
            v-if="!isLogin || !openContract"
            :defaultColorClass="loginButton.class"
            :hoverColorClass="loginButton.class"
            :activeColorClass="loginButton.class"
            @click="loginButtonClick()"
            width="100%"
            style="font-size: 14px; margin-right: 0px"
          >
            {{ loginButton.text }}
          </c-button>
          <template v-if="isLogin && openContract">
            <c-button
              :defaultColorClass="buttosContent.buyButton.class"
              :hoverColorClass="buttosContent.buyButton.class"
              :activeColorClass="buttosContent.buyButton.class"
              @click="submitForm('BUY')"
              :disabled="isSubmitDisbled"
              paddingW="10px"
              width="140px"
            >
              {{ buttosContent.buyButton.text }}
            </c-button>
            <c-button
              :defaultColorClass="buttosContent.sellButton.class"
              :hoverColorClass="buttosContent.sellButton.class"
              :activeColorClass="buttosContent.sellButton.class"
              @click="submitForm('SELL')"
              :disabled="isSubmitDisbled"
              paddingW="10px"
              width="140px"
            >
              {{ buttosContent.sellButton.text }}
            </c-button>
          </template>
        </div>
        <!-- 成本 -->
        <div class="hold-position">
          <div class="left">
            <label>
              <!-- 成本 -->
              {{ lanText.text5 }}
            </label>
            <span>{{ thousandsComma(canBuyCostNumber) }} {{ marginCoin }}</span>
          </div>
          <div class="right">
            <label>
              <!-- 成本 -->
              {{ lanText.text5 }}
            </label>
            <span>{{ thousandsComma(canSellCostNumber) }} {{ marginCoin }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 强制提醒(二次确认) -->
    <forcedReminder
      :dataInfo="confirmData"
      :isShow="forcedReminderShow"
      :close="closeDialog"
      @submitOrder="submitOrder"
    />
    <!-- 设置杠杆 -->
    <lever-component v-if="leverageDialogShow" :isShow="leverageDialogShow" :close="closeDialog" />
    <!-- 切换 保证金模式 -->
    <depositMode v-if="depositDialogShow" :isShow="depositDialogShow" :close="closeDialog" />
  </div>
</template>

<script>
import '@/components/modules/coTrade/style/tradeForm.scss';
import {
  fixD, division, getDigit, cut, thousandsComma, myStorage, nul,
} from '@/utils';
import { fixUpDownColor } from '@/utils/storage';

import formInput from './component/form-input.vue';
import forcedReminder from './component/forced-reminder.vue';
// 调整杠杆弹框
import leverComponent from './component/lever.vue';
// 保证金模式 全仓 逐仓 切换
import depositMode from './component/depositMode.vue';

export default {
  components: {
    formInput,
    forcedReminder,
    leverComponent,
    depositMode,
  },
  mounted() {
    this.init();
  },
  // 组价离开前执行
  beforeDestroy() {
    clearInterval(this.assetsInter);
  },
  data() {
    return {
      // 按钮颜色class类型
      showClassType: null,
      // 交易类型 1开仓 2 平仓
      transactionType: 1,
      // 1 限价 2 市价 3 条件
      currentCategory: 1,
      // 是否是市价
      isMarket: false,
      // 只减仓
      zhiJianCang: false,
      // 百分比值
      percentageVlaue: null,
      // 百分比值鼠标移入效果
      percentageVlaueHover: null,
      // 下单按钮是否OK
      isSubmitDisbled: false,
      // 是否显示杠杆弹窗
      leverageDialogShow: false,
      // 是否显示 二次确认弹框
      forcedReminderShow: false,
      // 是否选中了订单类型
      isCheckedOrdeType: null,
      // 订单类型对象{}
      ordeType: {},
      // 鼠标移入订单类型对象
      hoverOrdeType: {},
      // buy买入、sell卖出？
      sideType: null,
      // 提交防止连击
      submitFlag: true,
      // 到期时间
      expireTime: '14',

      formData_1: {
        title: '', // '价格',
        units: this.priceUnit,
        fix: 8,
        isShow: true,
        errorText: null,
        value: null,
      },
      formData_2: {
        title: '', // '价格',
        units: this.priceUnit,
        fix: 8,
        isShow: false,
        errorText: null,
        value: null,
      },
      formData_3: {
        title: '', // '数量',
        units: '', // '张',
        fix: 8,
        isShow: true,
        errorText: null,
        value: null,
      },
      // 下单提交数据
      submitData: null,
      // 二次确认数据
      confirmData: {},
      // 当前合约最新平均价
      activeNewPrice: 0,
      // 持仓模式 1：单向持仓 2：双向持仓
      positionModel: myStorage.get('positionModel') || 2,
      // 切换保证金模式弹框
      depositDialogShow: false,
      // 是否显示下单类型选项类表
      ordeTypePtions: false,
      buyOnePrice: 0,
      sellOnePrice: 0,
      activePrice: 0,
    };
  },
  computed: {
    /**
     * 标记价格
     */
    tagPrice() {
      if (this.$store.state.future && this.$store.state.future.publicMarkertInfo) {
        return this.$store.state.future.publicMarkertInfo.tagPrice;
      }
      return null;
    },

    /**
     * 当触发价和标记价价差在±0.3%以内就拦截提示
     * 因为标记价是不变的,因此除以标记价
     */
    isCloseToMarked() {
      let result = false;
      if (this.currentCategory === 3 && this.triggerPrice && this.tagPrice) {
        const triggerPrice = Number(this.triggerPrice);
        const tagPrice = Number(this.tagPrice);
        const closeRatio = (Math.abs(triggerPrice - tagPrice) / tagPrice);
        if (closeRatio <= 0.003) {
          result = true;
        }
      }
      return result;
    },
    // 是否 是云合约在iframe中调用
    isIframe() {
      return this.$store.state.future.isIframe;
    },
    // 当前合约保证金模式
    marginModelText() {
      // 全仓|逐仓  分仓|合仓
      const conf = this.userConfig || {};
      const margin = {
        1: this.$t('futures.currentSymbol.marginModel1'),
        2: this.$t('futures.currentSymbol.marginModel2'),
      };
      const layout = {
        1: this.$t('futures.depositMode.merge'),
        2: this.$t('futures.depositMode.split'),
      };

      return `${margin[conf.marginModel || 1]}${layout[conf.positionLayout || 1]}`;
    },
    lanText() {
      return {
        mPrice: this.$t('futures.tradeForm.mPrice'),
        textjz: this.$t('futures.tradeForm.textjz'),
        text1: this.$t('futures.tradeForm.text1'),
        text2: this.$t('futures.tradeForm.text2'),
        text3: this.$t('futures.tradeForm.text3'),
        text4: this.$t('futures.tradeForm.text4'),
        text5: this.$t('futures.tradeForm.text5'),
        text6: this.$t('futures.tradeForm.text6'),
        text7: this.$t('futures.tradeForm.text7'),
        text8: this.$t('futures.tradeForm.text8'),
        text9: this.$t('futures.tradeForm.text9'),
        text10: this.$t('futures.tradeForm.text10'),
        text11: this.$t('futures.tradeForm.text11'),
        text12: this.$t('futures.tradeForm.text12'),
        text13: this.$t('futures.tradeForm.text13'),
        text14: this.$t('futures.tradeForm.text14'),
        text15: this.$t('futures.tradeForm.text15'),
        text16: this.$t('futures.tradeForm.text16'),
        text17: this.$t('futures.tradeForm.text17'),
        text18: this.$t('futures.tradeForm.text18'),
        text19: this.$t('futures.tradeForm.text19'),
        text20: this.$t('futures.tradeForm.text20'),
        text21: this.$t('futures.tradeForm.text21'),
        text22: this.$t('futures.tradeForm.text22'),
        text23: this.$t('futures.tradeForm.text23'),
        text24: this.$t('futures.tradeForm.text24'),
        text25: this.$t('futures.tradeForm.text25'),
        text26: this.$t('futures.tradeForm.text26'),
        text27: this.$t('futures.tradeForm.text27'),
        text28: this.$t('futures.tradeForm.text28'),
        text29: this.$t('futures.tradeForm.text29'),
        text30: this.$t('futures.tradeForm.text30'),
        text31: this.$t('futures.tradeForm.text31'),
        text32: this.$t('futures.tradeForm.text32'),
        text33: this.$t('futures.tradeForm.text33'),
        text34: this.$t('futures.tradeForm.text34'),
        text35: this.$t('futures.tradeForm.text35'),
        text36: this.$t('futures.tradeForm.text36'),
        text37: this.$t('futures.tradeForm.text37'),
        text38: this.$t('futures.tradeForm.text38'),
        text39: this.$t('futures.tradeForm.text39'),
        text40: this.$t('futures.tradeForm.text40'),
        text41: this.$t('futures.tradeForm.text41'),
        text42: this.$t('futures.tradeForm.text42'),
        text43: this.$t('futures.tradeForm.text43'),
        text44: this.$t('futures.tradeForm.text44'),
        text45: this.$t('futures.tradeForm.text45'),
        text46: this.$t('futures.tradeForm.text46'),
        text47: this.$t('futures.tradeForm.text47'),
        text48: this.$t('futures.tradeForm.text48'),
        text49: this.$t('futures.tradeForm.text49'),
        text50: this.$t('futures.tradeForm.text50'),
        text51: this.$t('futures.tradeForm.text51'),
        text52: this.$t('futures.tradeForm.text52'),
        text53: this.$t('futures.tradeForm.text53'),
        text56: this.$t('futures.tradeForm.text56'),
        text57: this.$t('futures.tradeForm.text57'),
        text58: this.$t('futures.tradeForm.text58'),
        text59: this.$t('futures.tradeForm.text59'),
      };
    },
    // 是否登录
    isLogin() {
      if (this.$store.state.baseData.isLogin) {
        return this.$store.state.baseData.isLogin;
      }
      return false;
    },
    // 用户配置信息
    userConfig() {
      return this.$store.state.future.futureUserConfig;
    },
    // 保证金模式(1 全仓，2 仓逐)
    marginModel() {
      return this.userConfig ? this.userConfig.marginModel : 1;
    },
    // 持仓类型(1 合仓，2 分仓)
    positionLayout() {
      return this.userConfig ? this.userConfig.positionLayout : 1;
    },
    // 当前合约ID
    contractId() {
      return this.$store.state.future.contractId;
    },
    // 当前合约价格单位
    priceUnit() {
      return this.$store.state.future.priceUnit;
    },
    // 当前合约价格精度
    pricefix() {
      return this.$store.state.future.pricefix;
    },
    // 到期时间
    planTypeList() {
      return [
        {
          name: this.lanText.text16, // '24H',
          id: '1',
        },
        {
          name: this.lanText.text17, // '7天',
          id: '7',
        },
        {
          name: this.lanText.text18, // '14天',
          id: '14',
        },
        {
          name: this.lanText.text19, // '30天',
          id: '30',
        },
      ];
    },
    // 是否开通了合约交易
    openContract() {
      return this.$store.state.future.openContract;
    },
    // 数量单位
    volUnit() {
      return this.$store.state.future.coUnit;
    },
    // 当前合约面值
    multiplier() {
      return Number(this.$store.state.future.multiplier) || 1;
    },
    // 当前合约名称
    contractName() {
      return this.$store.state.future.contractName;
    },
    // 当前合约币对
    contractSymbol() {
      return this.$store.state.future.contractSymbol;
    },
    // 当前合约数量精度
    volfix() {
      if (this.coUnitType === 1) {
        return this.$store.state.future.volfix;
      }
      return 0;
    },
    // 数量单位类型Number 1标的货币, 2张
    coUnitType() {
      return this.$store.state.future.coUnitType;
    },
    // 当前合约信息
    contractInfo() {
      return this.$store.state.future.contractInfo;
    },
    // 当前合约币对信息
    coinResultVo() {
      if (this.contractInfo) {
        return this.contractInfo.coinResultVo;
      }
      return {};
    },
    // 标的货币（数量单位 base）
    baseCoin() {
      if (this.contractInfo) {
        return this.contractInfo.base;
      }
      return null;
    },
    // 计价货币
    quoteCoin() {
      if (this.contractInfo) {
        return this.contractInfo.quote;
      }
      return null;
    },
    // 标的货币（合约面值单位）
    multiplierCoin() {
      if (this.contractInfo) {
        return this.contractInfo.multiplierCoin;
      }
      return null;
    },
    // 标的货币精度（合约面值）
    multiplierFix() {
      if (this.contractInfo) {
        return getDigit(this.contractInfo.multiplier);
      }
      return 4;
    },
    // 当前合约保证金币种
    marginCoin() {
      if (this.contractInfo) {
        return this.contractInfo.marginCoin;
      }
      return '';
    },
    // 当前合约保证金币种精度
    marginCoinFix() {
      if (this.contractInfo && this.contractInfo.coinResultVo) {
        return this.contractInfo.coinResultVo.marginCoinPrecision;
      }
      return 4;
    },
    // 用户合约资产
    accountBalanceMap() {
      return this.$store.state.future.futureAccountBalance;
    },
    accountBalance() {
      if (this.accountBalanceMap && this.marginCoin) {
        return this.accountBalanceMap[this.marginCoin];
      }
      return {};
    },
    // 可用
    canUseAmount() {
      if (this.isLogin && this.accountBalance && this.accountBalance.canUseAmount !== '--') {
        return fixD(this.accountBalance.canUseAmount, this.marginCoinFix);
      }
      return 0;
    },
    // 当前合约杠杆倍数
    nowLevel() {
      if (this.userConfig) {
        return this.userConfig.nowLevel || 20;
      }
      return 20;
    },

    // 最高手续费率
    maxFeeRate() {
      if (this.userConfig) {
        return this.userConfig.maxFeeRate;
      }
      return 0;
    },

    // 当前合约保证金汇率
    marginRate() {
      if (this.contractInfo && this.contractInfo.marginRate) {
        return this.contractInfo.marginRate;
      }
      return 1;
    },
    // 当前合约方向（1正向、0反向）
    contractSide() {
      if (this.contractInfo) {
        return this.contractInfo.contractSide;
      }
      return 1;
    },
    // 当前合约可平数量
    activeCanClose() {
      const { activeCanClose } = this.$store.state.future;
      let obj = {};
      if (activeCanClose) {
        obj = activeCanClose[this.contractName];
      }
      return obj;
    },
    // 仓位方向（开仓 还是平仓）
    orderSide() {
      let open = 'OPEN';
      if (this.zhiJianCang || this.transactionType === 2) {
        open = 'CLOSE';
      }
      return open;
    },
    // 百分比列表
    percentageList() {
      return [10, 20, 50, 100];
    },
    // 开仓 平仓 Tab
    switchTradeTypeList() {
      return [
        {
          id: 1,
          text: this.lanText.text20, // '开仓',
          classes: this.transactionType === 1 ? 'main-cl' : 'gray-cl',
        },
        {
          id: 2,
          disabled: this.hasSplitPosition, // 持有分仓仓位时，平仓板块置灰
          text: this.lanText.text21, // '平仓',
          classes: [this.transactionType === 2 ? 'main-cl' : 'gray-cl', this.hasSplitPosition ? 'disabled' : ''].join(' '),
        },
      ];
    },
    // 限价单\市价单\条件单
    categoryList() {
      return [
        {
          id: 1,
          text: this.lanText.text22, // '限价单',
          classes: this.currentCategory === 1 ? 'main-cl' : 'gray-cl',
        },
        {
          id: 2,
          text: this.lanText.text23, // '市价单',
          classes: this.currentCategory === 2 ? 'main-cl' : 'gray-cl',
        },
        {
          id: 3,
          text: this.lanText.text24, // '条件单',
          classes: this.currentCategory === 3 ? 'main-cl' : 'gray-cl',
        },
      ];
    },
    // 可买 可卖标题文案
    openableData() {
      if (this.zhiJianCang || this.transactionType === 2) {
        return {
          buyText: this.lanText.text25, // '可平空',
          sellText: this.lanText.text26, // '可平多',
        };
      }
      return {
        buyText: this.lanText.text27, // '可买',
        sellText: this.lanText.text28, // '可卖',
      };
    },
    // 订单类型列表
    ordeTypeList() {
      return [
        {
          title: this.lanText.text29, // '只做maker',
          // '只做Maker（Post-Only）订单保证用户只做maker，该订单不会立即在市场成交，假如此委托会立即与已有委托单成交，那么此委托单将被立即取消。',
          text: this.lanText.text30,
          id: 5,
        },
        {
          title: 'IOC',
          // text: 'IOC（Immediately or Cancel）订单若不能立即成交则立即取消未成交的部分。',
          text: this.lanText.text31,
          id: 3,
        },
        {
          title: 'FOK',
          // text: 'FOK（Fill or Kill）订单若不能全部成交则立即全部取消。',
          text: this.lanText.text32,
          id: 4,
        },
      ];
    },
    // login 按钮信息
    loginButton() {
      if (this.isLogin && !this.openContract) {
        return {
          text: this.lanText.text33, // '开通合约交易',
          class: 'blue-bg buyBtn u-16-cl',
        };
      }
      return {
        text: this.lanText.text34, // '登录后进行交易',
        class: 'blue-bg buyBtn u-16-cl',
      };
    },
    // 按钮信息
    buttosContent() {
      if (this.transactionType === 2 || this.zhiJianCang) {
        return {
          buyButton: {
            text: this.lanText.text35, // '买入平空',
            class: 'color-up-bg buyBtn white-cl',
          },
          sellButton: {
            text: this.lanText.text36, // '卖出平多',
            class: 'color-down-bg sellBtn white-cl',
          },
        };
      }
      if (this.positionModel === 2) {
        return {
          buyButton: {
            text: this.lanText.text37, // '买入开多',
            class: 'color-up-bg buyBtn white-cl',
          },
          sellButton: {
            text: this.lanText.text38, // '卖出开空',
            class: 'color-down-bg sellBtn white-cl',
          },
        };
      }
      return {
        buyButton: {
          text: this.lanText.text39, // '买入做多',
          class: 'color-up-bg buyBtn white-cl',
        },
        sellButton: {
          text: this.lanText.text40, // '卖出做空',
          class: 'color-down-bg sellBtn white-cl',
        },
      };
    },
    // 是否是 市价开仓
    isOpenAndIsMarket() {
      // 市价单 && 不是只减仓
      // 条件市价 && 不是只减仓 && transactionType=== 1 开仓  2平仓
      if (
        (this.currentCategory === 2 || this.isMarket)
        && !this.zhiJianCang
        && this.transactionType === 1
      ) {
        return true;
      }
      return false;
    },
    // 输入的价格
    inputPrice() {
      // 市价
      if (this.currentCategory === 2 || this.isMarket) {
        return 0;
      }
      // 条件单
      if (this.currentCategory === 3) {
        return this.formData_2.value;
      }
      return Number(this.formData_1.value);
    },
    // 数量(张数) || 市价的开仓价值
    inputVolume() {
      // 限价的数量 and 市价的开仓价值
      let volume = this.formData_3.value;
      // 如果单位是标记货币 && 不是市价开仓(开仓价值)
      if (this.coUnitType === 1 && !this.isOpenAndIsMarket && volume) {
        // 转换成张
        volume = division(volume, this.multiplier);
      }
      return Number(volume) || 0;
    },
    // 条件单的触发价
    triggerPrice() {
      if (this.currentCategory === 3) {
        return this.formData_1.value;
      }
      return null;
    },

    // 提交时的订单类型
    submitOrderType() {
      // 订单类型 (1 limit， 2 market，3 IOC，4 FOK，5 POST_ONLY)
      let type = this.currentCategory;

      // bugfix 20030404 当限价单&市价的时候type传2
      if (this.currentCategory === 3) {
        type = this.isMarket ? 2 : 1;
      }

      if (this.currentCategory !== 2 && !this.isMarket) {
        if (this.isCheckedOrdeType && this.ordeType && this.ordeType.id) {
          type = this.ordeType.id;
        }
      }

      console.log('--------订单类型关键字段-----------');
      // 1 限价 2 市价 3 条件
      console.log('订单类型(currentCategory):', this.currentCategory);
      console.log('是否条件单市价(isMarket):', this.isMarket);
      console.log('多选框选择事件(isCheckedOrdeType):', this.isCheckedOrdeType);
      console.log('订单类型对象(ordeType):', this.ordeType);
      console.log('result(type):', type);
      console.log('--------订单类型关键字段-----------');

      return type;
    },
    // 开仓价值 约等于
    worthRate() {
      // 正向： 开仓价值 / 本交易所最新价格 / 保证金汇率(币)
      // 正向： 开仓价值 / 本交易所最新价格 / 保证金汇率(张)
      // 反向： 开仓价值 * 本交易所最新价格 / 保证金汇率(币)
      // 反向： 开仓价值 * 本交易所最新价格 / 保证金汇率(张)
      // this.marginRate：保证金汇率
      // this.multiplier： 合约面值
      const value = this.countPercentageVlaue() || this.inputVolume;
      let V1 = '';
      if (value && this.activePrice) {
        // 正向
        if (this.contractSide === 1) {
          V1 = division(value, this.activePrice);
        } else {
          // 反向
          V1 = nul(value, this.activePrice);
        }
        if (V1) {
          return fixD(division(V1, this.marginRate), this.multiplierFix);
        }
      }
      return 0;
    },
    // 价值
    worthValue() {
      let volume = this.countPercentageVlaue() || this.inputVolume;
      let price = this.formData_1.value;
      if (this.currentCategory === 3) {
        price = this.formData_2.value;
      }
      if (volume && price) {
        volume = nul(volume, this.multiplier);
        // 正向合约
        if (this.contractSide === 1) {
          return fixD(nul(volume, price), this.pricefix);
        }
        // 反向合约
        // const { volfix } = this.$store.state.future;
        return fixD(division(volume, price), this.marginCoinFix);
      }
      return 0;
    },

    // 计算器相关
    // 用户信息配置-可持有仓位上限
    leverOriginCeiling() {
      if (this.userConfig) {
        return this.userConfig.leverCeiling;
      }
      return null;
    },
    // 当前合约最大可开额度
    setMaxNumber() {
      let num = 0;
      if (this.leverOriginCeiling) {
        const keyArr = Object.keys(this.leverOriginCeiling);
        keyArr.sort((a, b) => parseFloat(a) - parseFloat(b));
        let nextL = 0;
        for (let index = 0; index < keyArr.length; index += 1) {
          if (Number(this.nowLevel) > nextL && Number(this.nowLevel) <= keyArr[index]) {
            num = this.leverOriginCeiling[keyArr[index]];
          }
          nextL = keyArr[index];
        }
        // 标的货币
        return num;
      }
      return num;
    },
    // 持仓列表
    positionList() {
      return this.$store.state.future.positionList || [];
    },
    // 当前币对是否持有分仓仓位，如果有，平仓板块置灰
    hasSplitPosition() {
      return !!this.positionList.find(i => i.positionLayout === 2 && i.contractId === this.contractId);
    },
    // 普通委托列表
    currentOrderLis() {
      return this.$store.state.future.currentOrderLis || [];
    },
    // 获取当前合约同方向持仓仓位价值
    positionMaxBalance() {
      const value = {
        buy: 0,
        sell: 0,
      };
      if (this.positionList.length) {
        this.positionList.forEach((item) => {
          if (this.contractId === item.contractId) {
            // if (item.orderSide === 'BUY') {
            value.buy += item.positionBalance;
            // } else {
            value.sell += item.positionBalance;
            // }
          }
        });
      }
      return value;
    },
    // 当前合约同方向未成交委托价值
    orderMaxBalance() {
      const value = {
        buy: 0,
        sell: 0,
      };
      if (this.currentOrderLis.length) {
        this.currentOrderLis.forEach((item) => {
          if (this.contractId === item.contractId && item.open === 'OPEN') {
            // if (item.side === 'BUY') {
            value.buy += item.orderBalance;
            // } else {
            value.sell += item.orderBalance;
            // }
          }
        });
      }
      return value;
    },
    // 计算
    // 当前合约最大可开额度-当前合约同方向持仓仓位价值-当前合约同方向未成交委托价值
    V1Buy() {
      return cut(cut(this.setMaxNumber, this.positionMaxBalance.buy), this.orderMaxBalance.buy);
    },
    V1Sell() {
      return cut(cut(this.setMaxNumber, this.positionMaxBalance.sell), this.orderMaxBalance.sell);
    },
    // 价格取值规则：
    // 委托价格为限价：用户设置的限价价格
    // 委托价格为市价：取最新价格，买一价, 卖一价 三者间的中位数
    priceVal() {
      // 市价
      if (this.currentCategory === 2 || this.isMarket) {
        return this.activePrice;
      }
      // 限价
      return this.inputPrice;
    },
    // 最大可买
    maxBuyNumber() {
      //  正向 & 张数
      if (!this.canUseAmount || !this.V1Buy || !this.priceVal || this.V1Buy.toString() === 'NaN') {
        return 0;
      }
      if (this.contractSide === 1 && this.coUnitType === 2) {
        // V1Buy * 保证金汇率 / (最新价格 * 合约面值)
        return division(nul(this.V1Buy, this.marginRate), nul(this.priceVal, this.multiplier));
      }
      // 反向 & 张数
      if (this.contractSide === 0 && this.coUnitType === 2) {
        // V1Buy * 价格 / 面值
        return division(nul(this.V1Buy, this.priceVal), this.multiplier);
      }
      // 正向 & 量
      if (this.contractSide === 1 && this.coUnitType === 1) {
        // V1Buy * 保证金汇率 / 价格
        return division(nul(this.V1Buy, this.marginRate), this.priceVal);
      }
      // 反向 & 量
      if (this.contractSide === 0 && this.coUnitType === 1) {
        // V1Buy * 价格
        return nul(this.V1Buy, this.priceVal);
      }
      return 0;
    },
    // 最大可卖
    maxSellNumber() {
      if (
        !this.canUseAmount
        || !this.V1Sell
        || !this.priceVal
        || this.V1Sell.toString() === 'NaN'
      ) {
        return 0;
      }
      //  正向 & 张数
      if (this.contractSide === 1 && this.coUnitType === 2) {
        // V1Sell * 保证金汇率 / (最新价格 * 合约面值)
        return division(nul(this.V1Sell, this.marginRate), nul(this.priceVal, this.multiplier));
      }
      // 反向 & 张数
      if (this.contractSide === 0 && this.coUnitType === 2) {
        // V1Sell * 价格 / 面值
        return division(nul(this.V1Sell, this.priceVal), this.multiplier);
      }
      // 正向 & 量
      if (this.contractSide === 1 && this.coUnitType === 1) {
        // V1Sell * 保证金汇率 / 价格
        return division(nul(this.V1Sell, this.marginRate), this.priceVal);
      }
      // 反向 & 量
      if (this.contractSide === 0 && this.coUnitType === 1) {
        // V1Sell  价格
        return nul(this.V1Sell, this.priceVal);
      }
      return 0;
    },

    // 买入可平数量
    maxCloseBuy() {
      let number = 0;
      let canClose = 0;
      if (this.activeCanClose && this.activeCanClose.BUY) {
        canClose = this.activeCanClose.BUY;
      }
      // 张
      if (this.coUnitType === 2) {
        number = canClose;
      } else {
        // 量
        number = nul(canClose, this.multiplier);
      }
      return number < 0 ? 0 : number;
    },

    // 卖出可平数量
    maxCloseSell() {
      let number = 0;
      let canClose = 0;
      if (this.activeCanClose && this.activeCanClose.SELL) {
        canClose = this.activeCanClose.SELL;
      }
      // 张
      if (this.coUnitType === 2) {
        number = canClose;
      } else {
        // 量
        number = nul(canClose, this.multiplier);
      }
      return number < 0 ? 0 : number;
    },
    // 可买 || 可平
    maxCanBuyNumber() {
      // 平仓 || 只减仓
      if (this.transactionType === 2 || this.zhiJianCang) {
        return fixD(this.maxCloseSell, this.volfix);
      }
      const number = this.calculateMaxNumber(1); // senge
      if (number < 0) return 0;
      return fixD(number, this.volfix);
    },
    // 可卖 || 可平
    maxCanSellNumber() {
      // 平仓 || 只减仓
      if (this.transactionType === 2 || this.zhiJianCang) {
        return fixD(this.maxCloseBuy, this.volfix);
      }
      const number = this.calculateMaxNumber(2); // senge
      if (number < 0) return 0;
      return fixD(number, this.volfix);
    },
    // 买入成本
    canBuyCostNumber() {
      if (this.isLogin) {
        return fixD(this.calculateCostNumber('BUY'), this.marginCoinFix);
      }
      return 0;
    },

    // 卖出成本
    canSellCostNumber() {
      if (this.isLogin) {
        return fixD(this.calculateCostNumber('SELL'), this.marginCoinFix);
      }
      return 0;
    },
  },
  watch: {
    // 用户配置信息
    userConfig(val) {
      if (val) {
        //
        this.positionModel = val.positionModel;
        // 只减仓
        this.zhiJianCang = false;
        // 交易类型 1开仓 2 平仓
        this.transactionType = 1;
        // 1 限价 2 市价 3 条件
        // this.currentCategory = 1;
        // 条件单是否是市价
        this.isMarket = false;
        // 只减仓
        this.zhiJianCang = false;
        // 设置表单布局
        this.setFormType();
        // 清空表单内容
        this.clearFormData();
      }
    },
    // 合约ID
    contractId() {
      // 清空表单内容
      this.clearFormData();
    },
    'formData_1.value': function formData1(value) {
      if (value && Number(value)) {
        this.formData_1.errorText = null;
      }
    },
    'formData_2.value': function formData2(value) {
      if (value && Number(value)) {
        this.formData_2.errorText = null;
      }
    },
    'formData_3.value': function formData3(value) {
      if (value && Number(value)) {
        this.formData_3.errorText = null;
      }
    },
    volUnit(val) {
      if (val) {
        this.setFormType();
      }
    },
    ordeTypeList() {
      const [ordeType] = this.ordeTypeList;
      this.ordeType = ordeType;
    },
  },
  methods: {
    fixUpDownColor,

    /**
     * 初始化监听
     */
    init() {
      // 监听喜好设置
      this.$bus.$on('set-future', (data) => {
        if (data && data.positionModel) {
          this.positionModel = data.positionModel;
        }
      });
      // 监听获取当前最新平均价格
      this.$bus.$on('ACTIVE_NEW_PRICE', (val) => {
        if (val) {
          this.activeNewPrice = val;
        }
      });
      // 监听点击盘口的价格
      this.$bus.$on('HANDEL_PRICE', (val) => {
        if (val) {
          this.formData_1.value = val;
        }
      });
      // 监听点击盘口的买一价格
      this.$bus.$on('ACTIVE_BUY_ONE_PRICE', (val) => {
        this.buyOnePrice = val || 0;
      });
      // 监听点击盘口的卖一价格
      this.$bus.$on('ACTIVE_SELL_ONE_PRICE', (val) => {
        this.sellOnePrice = val || 0;
      });
      // 监听点击盘口的最新价格
      this.$bus.$on('ACTIVE_ACTIVE_PRICE', (val) => {
        this.activePrice = val || 0;
      });
      this.setFormType();
      // 设置默认订单类型
      this.$nextTick(() => {
        const [ordeType] = this.ordeTypeList;
        this.ordeType = ordeType;
      });
      // 主动获取一次盘口数据 防止盘口先渲染 这里获取不到数据
      this.$emit('GET_DEPTH_INFO');
    },

    /**
     * 获取预成交价格
     * buyOrSell: 1买 2卖
     * 限价买入做多:委托价
     * 现价卖出做空:max(买一, 委托价)
     * 其中买卖一为空时,市价直接取最新价;限价优先取委托价,委托价为空时取最新价
     */
    getPreDealPrice(buyOrSell) {
      let preDealPrice = this.priceVal;
      console.log('-----------预成交价格计算关键指标--------------');
      console.log('卖一价:sellOnePrice', this.sellOnePrice);
      console.log('买一价:buyOnePrice', this.buyOnePrice);
      console.log('委托价:inputPrice', this.inputPrice);
      console.log('最新价:activePrice', this.activePrice);
      console.log('-----------预成交价格计算关键指标--------------');
      // 买入
      if (buyOrSell === 1) {
        // 限价单或者条件限价单 其余的都是市价单
        if (this.currentCategory === 1 || (this.currentCategory === 3 && !this.isMarket)) {
          preDealPrice = this.inputPrice || this.activePrice; // this.sellOnePrice ? Math.min(this.inputPrice, this.sellOnePrice) : this.inputPrice;
        } else {
          preDealPrice = this.activePrice; // this.sellOnePrice ? Math.min(this.activePrice, this.sellOnePrice) : this.activePrice;
        }
      }
      // 卖出
      if (buyOrSell === 2) {
        // 限价单或者条件限价单 其余的都是市价单
        if (this.currentCategory === 1 || (this.currentCategory === 3 && !this.isMarket)) {
          preDealPrice = this.buyOnePrice ? Math.max(this.inputPrice, this.buyOnePrice) : (this.inputPrice || this.activePrice);
        } else {
          preDealPrice = this.activePrice; // this.buyOnePrice ? Math.max(this.activePrice, this.buyOnePrice) : this.activePrice;
        }
      }
      return preDealPrice;
    },

    /**
    * 计算最大可开
    * 1.用可用计算最大可开
    *   最大可开张数(B)=向下取整[(可用余额*杠杆)/(预成交价格*合约单位 + 2*预成交价格*合约单位*最高手续费率*杠杆)]
    *   其中预成交价格:
    *      限价买入做多:委托价
    *      现价卖出做空:max(买一, 委托价)
    *      其中买卖一为空时,市价直接取最新价;现价优先取委托价,委托价为空时取最新价
    * 2.校验风险限额根据每个档位的仓位价值，计算每个档位当下可开张数，已开张数 =当前交易对持仓中+当前交易对开仓委托中数量最大可开张数 = min (杠杆档位最大张数已开张数，最大可开(B) )
    *
    * buyOrSell: 1 买入 2 卖出
    */
    calculateMaxNumber(buyOrSell) {
      this.$emit('GET_DEPTH_INFO');
      if (!this.canUseAmount || !this.priceVal) {
        return 0;
      }
      const preDealPrice = this.getPreDealPrice(buyOrSell);


      if (!preDealPrice) {
        return 0;
      }
      console.log('--------计算关键指标-----------');
      console.log('买入or卖出', buyOrSell === 1 ? '买入' : '卖出');
      console.log('canUseAmount 可用余额', this.canUseAmount);
      console.log('preDealPrice 预成交价格', preDealPrice);
      console.log('nowLevel 杠杆', this.nowLevel);
      console.log('marginRate 保证金汇率', this.marginRate);
      console.log('multiplier 合约单位', this.multiplier);
      console.log('maxFeeRate 最高手续费率', this.maxFeeRate);
      console.log('向下取整[(可用余额*杠杆)/(预成交价格*合约单位 + 2*预成交价格*合约单位*最高手续费率*杠杆)]');
      console.log('---------计算关键指标----------');
      // 向下取整[(可用余额*杠杆)/(预成交价格*合约单位 + 2*预成交价格*合约单位*最高手续费率*杠杆)]
      const V1 = Math.floor((this.canUseAmount * this.nowLevel) / (preDealPrice * this.multiplier + 2 * preDealPrice * this.multiplier * this.maxFeeRate * this.nowLevel));
      // coUnitType 2表示张 1表示标的货币
      if (this.coUnitType === 2) {
        return V1;
      }
      // 货币价格
      return V1 * this.multiplier;
    },

    // 显示弹框
    showDialog(type) {
      this.$bus.$emit(type);
    },

    getUserConfigSync(callback, type) {
      this.axios({
        url: this.$store.state.url.futures.getUserConfig,
        method: 'post',
        hostType: 'co',
        params: {
          contractId: this.contractId,
        },
      }).then((res) => {
        if (res.code === '0') {
          this.$store.commit('GET_USER_CONFIG', res.data);
          if (callback) {
            callback(type);
          }
        }
      });
    },

    // 开启弹框
    setShowDialog(type) {
      // 统一增加一个接口调用
      if (this.isLogin) {
        this.getUserConfigSync(this.showDialogLogic, type);
      } else {
        this.showDialogLogic(type);
      }
    },

    showDialogLogic(type) {
      // 显示开通合约交易弹框
      if (this.userConfig && !this.userConfig.openContract) {
        this.$bus.$emit('OPEN_FUTURE');
        return;
      }
      if (type === 'leverageDialogShow' && this.userConfig && !this.userConfig.levelCanSwitch) {
        // 本合约当前存在委托，不可调整杠杆
        this.$bus.$emit('tip', { text: this.$t('futures.tradeForm.text54'), type: 'error' });
        return;
      }
      if (type === 'depositDialogShow' && this.userConfig && !this.userConfig.marginModelCanSwitch) {
        // '本合约当前存在委托/仓位，不可调整仓位类型'
        this.$bus.$emit('tip', { text: this.$t('futures.tradeForm.text55'), type: 'error' });
        return;
      }

      if (!this.isLogin) {
        this.$bus.$emit('tip', { text: this.lanText.text34, type: 'error' });
      } else {
        this[type] = true;
      }
    },

    // 切换 开仓  和 平仓
    switchTradeType(item) {
      // 持有分仓仓位时，平仓板块置灰
      if (item.disabled) { return; }

      const type = item.id;
      if (this.transactionType !== type) {
        this.transactionType = type;
        this.setFormType();
        this.clearFormData();
      }
    },

    // 切换 /普通/高级限价/计划
    selectCategory(id) {
      if (this.currentCategory !== id) {
        this.currentCategory = id;
        // 条件单是否是市价
        this.isMarket = false;
        this.setFormType();
        this.clearFormData();
      }
    },

    // 条件单切换 市价 and 限价
    selectMarket() {
      if (this.isMarket) {
        this.formData_3.value = '';
      }
      this.isMarket = !this.isMarket;
      this.setFormType();
      this.clearFormData('isMarket');
    },
    // 清除百分比
    clearPercentage() {
      this.percentageVlaue = null;
      this.formData_3.value = null;
      this.formData_3.percentageVlaue = null;
      this.formData_1.percentageVlaue = null;
    },
    // 设置百分比
    setPercentageVlaue(value) {
      this.percentageVlaue = value;
      if (this.formData_3.isShow) {
        this.formData_3.percentageVlaue = value;
        this.formData_3.value = null;
        this.formData_3.errorText = null;
      } else {
        this.formData_1.percentageVlaue = value;
        this.formData_1.value = null;
        this.formData_1.errorText = null;
      }
    },
    // 计算百分比的数量
    countPercentageVlaue(type) {
      if (!this.percentageVlaue) return 0;
      const canNumber = type === 'BUY' ? this.maxCanBuyNumber : this.maxCanSellNumber;
      if (!canNumber) return 0;
      let number = 0;
      //  市价 开仓 非只减仓
      if (this.isOpenAndIsMarket) {
        // 百分比*可用*杠杆 / 保证金汇率 = 仓位价值
        const percentageVlaue = division(this.percentageVlaue, 100);
        // 百分比 * 可用
        const Np = nul(percentageVlaue, this.canUseAmount);
        // 可开价值 = (可用金额*杠杆)/ (1+ 2*最高手续费率*杠杆)精度按照前端精度，向下截取
        console.log('---------计算百分比数量关键数据----------');
        console.log('可用金额:', Np);
        console.log('杠杆:', this.nowLevel);
        console.log('最高手续费率:', this.maxFeeRate);
        console.log('公式:', '(可用金额*杠杆)/ (1+ 2*最高手续费率*杠杆)');
        console.log('-----------计算百分比数量关键数据--------');
        const val1 = division(nul(Np, this.nowLevel), (1 + 2 * this.maxFeeRate * this.nowLevel));
        const val3 = val1; // senge
        number = fixD(val3, this.pricefix);
      } else {
        // 百分比*（可买 || 可卖）= 数量
        number = nul(division(this.percentageVlaue, 100), canNumber);
        // 如果当前单位是标的货币
        if (this.coUnitType === 1 && number) {
          // 换算成（张）
          number = fixD(division(number, this.multiplier), 0);
        }
        if (this.coUnitType === 2) {
          number = fixD(number, 0);
        }
      }
      return number;
    },

    /**
     * 初始化表单
     * 设置表单
     */
    setFormType() {
      this.formData_1.promptText = null;
      this.formData_3.promptText = null;

      // 限价
      if (this.currentCategory === 1) {
        this.formData_1.isShow = true;
        this.formData_1.title = this.lanText.text11; //  '委托价格';
        this.formData_1.units = this.priceUnit;
        this.formData_1.fix = this.pricefix;
        this.formData_3.isShow = true;
        this.formData_3.units = this.volUnit;
        this.formData_3.fix = this.volfix;
      }

      // 市价
      if (this.currentCategory === 2) {
        this.isCheckedOrdeType = false;
        // 平仓 || 只减仓
        if (this.transactionType === 2 || this.zhiJianCang) {
          this.formData_1.isShow = false;
          this.formData_3.isShow = true;
        } else {
          this.formData_1.isShow = false;
          this.formData_3.isShow = true;
        }
      }
      // 条件单
      if (this.currentCategory === 3) {
        this.formData_1.isShow = true;
        this.formData_2.isShow = true;
        this.formData_3.isShow = true;
        this.formData_1.title = this.lanText.text12; // '触发价';
        // '当该合约的最新成交价达到该价格时，系统将按照你设置的下单价格和下单数量为你下单。';
        this.formData_1.promptText = this.lanText.text13;
        this.formData_2.title = this.lanText.text11; // '委托价格';
        this.formData_1.units = this.priceUnit;
        this.formData_2.fix = this.pricefix;
        this.formData_1.fix = this.pricefix;
      } else {
        this.formData_2.isShow = false;
      }
      // 如果是市价开仓
      if (this.isOpenAndIsMarket) {
        this.formData_3.title = this.lanText.text14; // '开仓价值';
        // '需要开的仓位的价值，仓位价值 = 仓位数量 * 成交价格，实际成交的仓位数量与成交时的成交价格有关。';
        this.formData_3.promptText = this.lanText.text15;
        // 正向
        if (this.contractSide === 1) {
          this.formData_3.units = this.priceUnit;
          this.formData_3.fix = this.pricefix;
        } else {
          // 反向
          const { volfix } = this.$store.state.future;
          this.formData_3.units = this.baseCoin;
          this.formData_3.fix = volfix;
        }
      } else {
        this.formData_3.title = this.lanText.text53; // '委托数量';
        this.formData_3.units = this.volUnit;
        this.formData_3.fix = this.volfix;
      }
      this.setHeight();
    },

    // 清除表单数据
    clearFormData(type) {
      if (type !== 'isMarket') {
        this.formData_1.value = null;
      }
      // this.isMarket = false;
      this.percentageVlaue = null;
      this.formData_2.value = null;
      this.formData_1.errorText = null;
      this.formData_2.errorText = null;
      this.formData_3.errorText = null;
      this.formData_3.value = null;
      // 百分数
      this.formData_1.percentageVlaue = null;
      this.formData_3.percentageVlaue = null;
      // 卖一\买一\现价
      this.$emit('GET_DEPTH_INFO');
      this.setHeight();
    },
    // 表单输入事件
    changeInput(type, value) {
      this[type].value = value;
    },
    // 多选框选择事件(只减仓)
    checkoutClick(type) {
      this.zhiJianCang = type;
      this.setFormType();
    },
    // 多选框选择事件(只减仓)
    checkedOrdeTypeclick(type) {
      this.isCheckedOrdeType = type;
    },
    // 单选框 选择事件
    radioClick(type) {
      this.ordeType = type;
      this.ordeTypePtions = false;
    },
    // 显示开通合约弹框/登录
    loginButtonClick() {
      if (!this.isLogin) {
        if (this.isIframe) {
          window.parent.postMessage('login', '*');
        } else {
          this.$router.push('/login');
        }
      } else {
        // 显示开通合约弹框
        this.$bus.$emit('OPEN_FUTURE');
      }
    },
    // 表单输入值大小验证
    formNumberVerify() {
      let flag = true;
      this.formData_1.errorText = null;
      this.formData_2.errorText = null;
      this.formData_3.errorText = null;
      const { sideType } = this;

      // 当前输入的价格和最新价的比例 (当前价格 - 输入的价格) / 当前价格
      if (this.inputPrice) {
        const range = Math.abs(
          division(cut(this.activePrice, this.inputPrice), this.activePrice),
        );
        // 买单最小价格偏离比 buyMinPriceRange    卖单最高价格偏离比 sellMaxPriceRange   最大价格比例 priceRange
        const { priceRange, buyMinPriceRange, sellMaxPriceRange } = this.coinResultVo;

        let chaFlag = true;
        if (sideType === 'SELL' && Number(this.inputPrice) < Number(this.activePrice)) {
          chaFlag = false;
        }
        if (sideType === 'BUY' && Number(this.inputPrice) > Number(this.activePrice)) {
          chaFlag = false;
        }

        let priceLimitError = ''; // 超过最小买单价 和 最高卖单价
        // 买单挂单的最小价格(买单最小价格偏离比 buyMinPriceRange) - 买单最小价格=最新成交价*（1-偏离比）
        if (sideType === 'BUY' && buyMinPriceRange) {
          const minBuy = nul(Number(this.activePrice), 1 - buyMinPriceRange);
          if (Number(this.inputPrice) < minBuy) {
            priceLimitError = this.lanText.text58;
          }
        }
        // 卖单最大价格偏离比(卖单最高价格偏离比 sellMaxPriceRange) - 卖单最高价格=最新成交价 *（1+偏离比）
        if (sideType === 'SELL' && sellMaxPriceRange) {
          const maxSell = nul(Number(this.activePrice), 1 + sellMaxPriceRange);
          if (Number(this.inputPrice) > maxSell) {
            priceLimitError = this.lanText.text59;
          }
        }
        if (priceLimitError) {
          if (this.currentCategory === 3) {
            this.formData_2.errorText = priceLimitError;
          } else {
            this.formData_1.errorText = priceLimitError;
          }
          flag = false;
        }

        console.log('---------range, priceRange----------');
        console.log('最新价:activePrice', this.activePrice);
        console.log('委托价:inputPrice', this.inputPrice);
        console.log('range', range);
        console.log('priceRange', priceRange);
        console.log('buyMinPriceRange', buyMinPriceRange);
        console.log('sellMaxPriceRange', sellMaxPriceRange);
        console.log('-----------range, priceRange--------');

        if (range > priceRange && !chaFlag) {
          if (this.currentCategory === 3) {
            this.formData_2.errorText = this.lanText.text41; // '价格偏差太大！';
          } else {
            this.formData_1.errorText = this.lanText.text41; // '价格偏差太大！';
          }
          flag = false;
        }
      }

      // 数量
      let vol = this.inputVolume;
      if (this.percentageVlaue) {
        vol = this.countPercentageVlaue(sideType);
      }

      if (vol) {
        // 验证市价开仓
        if (this.isOpenAndIsMarket) {
          // 市价（开仓价值）
          const { maxMarketMoney, minOrderMoney } = this.coinResultVo;
          if (vol > maxMarketMoney) {
            // 超出单次最大下单金额，最多可输入
            this.formData_3.errorText = `${this.lanText.text42}${maxMarketMoney} ${this.marginCoin}`;
            flag = false;
          }
          if (vol < minOrderMoney) {
            // 超出单次最小下单金额，最少需输入
            let coin = this.marginCoin;
            if (this.contractInfo.contractType !== 'E' && this.currentCategory === 2) {
              coin = this.quoteCoin;
            }

            this.formData_3.errorText = `${this.lanText.text43}${minOrderMoney} ${coin}`;
            flag = false;
          }
          // 百分比 * 可用
          // const val1 = fixD(division(
          //   nul(this.canUseAmount, this.nowLevel), this.marginRate,
          // ), this.pricefix);
          // const val2 = sideType === 'BUY' ? this.V1Buy : this.V1Sell; // senge
          // const number = Number(val1) < Number(val2) ? Number(val1) : Number(val2); // senge
          // if (vol > number) {
          //   this.formData_3.errorText = `${this.lanText.text57}`;
          //   flag = false;
          //   return false;
          // }
        } else {
          // 限价
          const { maxLimitVolume, minOrderVolume } = this.coinResultVo;
          //
          const canMaxNumber = sideType === 'SELL' ? this.maxCanSellNumber : this.maxCanBuyNumber;
          let canMaxNumberZhang = canMaxNumber;
          if (this.coUnitType === 1 && !this.isOpenAndIsMarket && canMaxNumber) {
            // 转换成张
            canMaxNumberZhang = division(canMaxNumber, this.multiplier);
          }
          // 超出最大数量
          if (vol > Number(canMaxNumberZhang)) {
            // 超出最大下单量，最多还可以下单
            this.formData_3.errorText = `${this.lanText.text56} ${canMaxNumber} ${this.volUnit}`;
            flag = false;
            return false;
          }

          if (vol > maxLimitVolume) {
            let Tn = maxLimitVolume;
            // 如果是标记货币
            if (this.coUnitType === 1) {
              Tn = nul(maxLimitVolume, this.multiplier);
            }
            // 超出单次最大下单量，最多可输入
            this.formData_3.errorText = `${this.lanText.text44}${Tn} ${this.volUnit}！`;
            flag = false;
          }
          // 超出最小数量
          if (vol < minOrderVolume) {
            let Tn = minOrderVolume;
            // 如果是标记货币
            if (this.coUnitType === 1) {
              Tn = nul(minOrderVolume, this.multiplier);
            }
            // 超出单次最小下单量，最少需输入
            this.formData_3.errorText = `${this.lanText.text45}${Tn} ${this.volUnit}！`;
            flag = false;
          }
          // 验证平仓数量 是否超出可平数量
          if (this.zhiJianCang || this.transactionType === 2) {
            // 可平数量
            const Kp = sideType === 'SELL' ? Number(this.maxCanSellNumber) : Number(this.maxCanBuyNumber);
            // 如果当前单位是标的货币
            if (this.coUnitType === 1) {
              vol = nul(vol, this.multiplier);
            }
            if (vol > Kp) {
              this.formData_3.errorText = this.lanText.text46; // '超出可平数量！';
              flag = false;
            }
          }
        }
      }

      this.setHeight();

      return flag;
    },
    // 表单 非空 验证
    formVerify() {
      let flag = true;
      const { sideType } = this;
      // 百分比数量
      const BfbVol = this.countPercentageVlaue(sideType);
      // 验证限价
      if (this.currentCategory === 1) {
        if (!this.inputPrice) {
          this.formData_1.errorText = this.lanText.text47; // '请输入价格!';
          flag = false;
        }
        if (!this.inputVolume && !BfbVol) {
          this.formData_3.errorText = this.lanText.text48; // '请输入数量!';
          flag = false;
        }
      }
      // 验证市价
      if (this.currentCategory === 2 && !BfbVol) {
        if (!this.inputVolume && this.orderSide === 'OPEN') {
          this.formData_3.errorText = this.lanText.text49; // '请输入开仓价值!';
          flag = false;
        }
        if (!this.inputVolume && this.orderSide === 'CLOSE') {
          this.formData_3.errorText = this.lanText.text48; // '请输入数量!';
          flag = false;
        }
      }
      // 验证条件单
      if (this.currentCategory === 3) {
        // 触发价
        if (!this.triggerPrice) {
          this.formData_1.errorText = this.lanText.text50; // '请输入触发价!';
          flag = false;
        }
        // 价格
        if (!this.inputPrice && !this.isMarket) {
          this.formData_2.errorText = this.lanText.text47; // '请输入价格!';
          flag = false;
        }
        // 数量
        if (!this.inputVolume && !this.isMarket && !BfbVol) {
          this.formData_3.errorText = this.lanText.text48; // '请输入数量!';
          flag = false;
        }
        if (!this.inputVolume && this.isMarket && this.orderSide === 'OPEN' && !BfbVol) {
          this.formData_3.errorText = this.lanText.text49; // '请输入开仓价值!';
          flag = false;
        }
      }
      this.setHeight();
      return flag;
    },
    // 验证保证金是否足够
    amountVerify() {
      // 保证金数量
      let marginCoinVol = this.canBuyCostNumber;
      // 确认按钮class
      if (this.sideType === 'SELL') {
        marginCoinVol = this.canSellCostNumber;
      }
      if (Number(marginCoinVol) > Number(this.canUseAmount)) {
        // 保证金余额不足！
        this.$bus.$emit('tip', { text: this.lanText.text51, type: 'error' });
        return false;
      }
      return true;
    },
    // 点击买入卖出按钮
    submitForm(sideType) {
      this.sideType = sideType;
      // 如果没有登录跳转登录页面
      if (!this.isLogin) {
        if (this.isIframe) {
          window.parent.postMessage('login', '*');
        } else {
          this.$router.push('/login');
        }
      }

      if (this.isCloseToMarked) {
        this.$bus.$emit('tip', { text: this.$t('contract.closeToMark'), type: 'error' });
        return false;
      }

      // 表单非空验证
      if (!this.formVerify()) return false;
      // 表单价格 数量 大小验证
      if (!this.formNumberVerify(sideType)) return false;
      // 验证保证金余额是够足够
      if (!this.amountVerify()) return false;

      // 百分比的数量 || 输入的数量 (张)
      const volume = this.countPercentageVlaue(sideType) || this.inputVolume;
      let submitVolume = volume;

      // 如果不是市价开仓
      if (!this.isOpenAndIsMarket && submitVolume) {
        // 转换成张
        submitVolume = fixD(submitVolume, 0);
      }

      this.submitData = {
        contractId: this.contractId, // 合约ID
        positionType: this.marginModel, // 保证金模式(1 全仓，2 仓逐)
        positionLayout: this.positionLayout, // 持仓类型(1 合仓，2 分逐)
        side: this.sideType, // 买卖方向（buy 买入，sell 卖出）
        leverageLevel: this.nowLevel, // 杠杆倍数
        price: this.inputPrice, // 下单价格(市价单传0)
        volume: submitVolume, // 下单数量(开仓 市价单：开仓价值)
        triggerPrice: this.triggerPrice, // 触发价格
        open: this.orderSide, // 开平仓方向(open 开仓，close 平仓)
        type: this.submitOrderType, // 订单类型 (1 limit， 2 market，3 IOC，4 FOK，5 POST_ONLY)
        isConditionOrder: this.currentCategory === 3, // 是否是条件单
        // expireTime: this.expireTime, // 到期时间
      };

      // 判断用户是否设置了开启二次确认
      if (this.userConfig && this.userConfig.pcSecondConfirm) {
        let sideTypeData = this.buttosContent.buyButton;
        // 保证金数量
        let marginCoinVol = this.canBuyCostNumber;
        // 确认按钮class
        let sideClass = 'color-up-bg';
        if (this.sideType === 'SELL') {
          sideTypeData = this.buttosContent.sellButton;
          marginCoinVol = this.canSellCostNumber;
          sideClass = 'color-down-bg';
        }
        // 数量
        let vol = `${volume} ${this.volUnit}`;
        // 市价开仓
        if (this.orderSide === 'OPEN' && (this.currentCategory === 2 || this.isMarket)) {
          // 反向
          let unit = this.contractInfo.base;
          // 正向
          if (this.contractSide === 1) {
            unit = this.priceUnit;
          }
          vol = `${volume} ${unit}`;
        } else if (this.coUnitType === 1) {
          // 如果当前单位是标的货币 就 把张 换算成 标的数量
          vol = `${fixD(nul(volume, this.multiplier), this.volfix)} ${this.volUnit}`;
        }
        this.confirmData = {
          // 币种
          symbol: this.contractSymbol,
          // 订单类型Number（1限价单、2市价单、3条件单）
          currentCategory: this.currentCategory,
          // 确认按钮文案（买入做多...）
          sideText: sideTypeData.text,
          // 确认按钮颜色class
          sideClass,
          // 是否是开仓市价单
          isOpenAndIsMarket: this.isOpenAndIsMarket,
          // 条件单 触发价
          triggerPrice: `${this.triggerPrice} ${this.priceUnit}`,
          // 价格
          price: this.inputPrice ? `${this.inputPrice} ${this.priceUnit}` : '市价',
          // 数量
          vol,
          marginCoin: `${marginCoinVol} ${this.marginCoin}`,
        };
        this.forcedReminderShow = true;
      } else {
        this.dialogConfirmLoading = true;
        this.submit();
      }
      return false;
    },
    // 下单提交
    submit() {
      if (this.submitFlag) {
        this.submitFlag = false;
        this.axios({
          url: this.$store.state.url.futures.orderCreate,
          hostType: 'co',
          method: 'post',
          params: this.submitData,
        }).then(({ code, msg }) => {
          if (code.toString() === '0') {
            this.clearFormData();
            this.$store.dispatch('getUserConfig');
            this.$store.dispatch('getPositionList');
            this.forcedReminderShow = false;
            this.$bus.$emit('CRAET-ORDER-SUCCESS');
            this.$bus.$emit('tip', { text: msg, type: 'success' });
          } else {
            this.$bus.$emit('tip', { text: msg, type: 'error' });
          }
          this.dialogConfirmLoading = false;
          this.submitFlag = true;
        });
      }
    },
    // 下单二次确认提交
    submitOrder(data) {
      if (data) {
        this.axios({
          url: this.$store.state.url.futures.editUserPageConfig,
          hostType: 'co',
          method: 'post',
          params: {
            pcSecondConfirm: 0,
            contractId: this.contractId,
          },
        }).then(({ code, msg }) => {
          if (code.toString() === '0') {
            this.$store.dispatch('getUserConfig');
          } else {
            this.$bus.$emit('tip', { text: msg, type: 'error' });
          }
        });
      }
      this.dialogConfirmLoading = true;
      this.submit();
    },
    // 关闭弹窗
    closeDialog() {
      // 关闭强制提醒（二次确认）弹框
      this.forcedReminderShow = false;
      // 关闭杠杆弹窗
      this.leverageDialogShow = false;
      // 关闭切换保证金模式弹框
      this.depositDialogShow = false;
    },
    // 选择 到期时间
    selectPlanType(val) {
      this.expireTime = val;
    },

    /**
     * 动态设置高度
     */
    setHeight() {
      let setTimer = setTimeout(() => {
        const layoutHeight = document.getElementById('layoutBlockTrade').clientHeight;
        const coTradeBoxHeight = document.getElementById('coTradeBox').clientHeight;
        const syHeight = layoutHeight - coTradeBoxHeight - 15;
        this.$bus.$emit('syHeight', syHeight);
        clearTimeout(setTimer);
        setTimer = null;
      }, 100);
    },

    /**
     * 千分位展示
     */
    thousandsComma(num) {
      if (num) {
        return thousandsComma(num);
      }
      return num;
    },

    /**
     * 鼠标滑过
     */
    evenHandMouseenter(key, type) {
      this[key] = type;
    },

    /**
     * 鼠标划出
     */
    evenHandMouseleave(key) {
      this[key] = null;
    },

    /**
     * 计算成本
     */
    calculateCostNumber(type) {
      let volume = this.inputVolume;
      if (this.percentageVlaue) {
        volume = this.countPercentageVlaue(type);
      }
      let number = 0;
      // 平仓 || 只减仓 （仓位价值）
      if (this.transactionType === 2 || this.zhiJianCang) return 0;

      // 20220425 限价改成预成交价格
      const preDealPrice = this.getPreDealPrice(type === 'BUY' ? 1 : 2);

      // 限价单 or 条件限价单 （数量）
      if (this.currentCategory === 1 || (this.currentCategory === 3 && !this.isMarket)) {
        if (!preDealPrice) return 0;
        // 反向 = 张数 * 面值 / 限价 / 杠杆 * 保证金汇率
        number = nul(
          division(division(nul(volume, this.multiplier), preDealPrice), this.nowLevel),
          this.marginRate,
        );
        // 正向 | 张数 * 面值 * 限价 / 杠杆 * 保证金汇率
        if (this.contractSide === 1) {
          number = nul(
            division(nul(nul(volume, this.multiplier), preDealPrice), this.nowLevel),
            this.marginRate,
          );
        }
        return number;
      }
      // 市价单 or 添加市价单
      if (this.currentCategory === 2 || (this.currentCategory === 3 && this.isMarket)) {
        // 反向 | 正向 = 开仓价值 / 杠杆 * 保证金汇率
        number = nul(division(volume, this.nowLevel), this.marginRate);
        return number;
      }
      return number;
    },
  },
};
</script>

<style lang="scss" scoped>
.tip-text {
  font-family: 'Medium' !important;
}
</style>
